import { getRouteFromPostType } from "~/lib/shared/getRouteFromPostType";
import { heDecodeOrDefault } from "~/lib/shared/html-utils";
import { PostItem } from "~/types/asgard/Vertical";
import { ContentItemWithImageProps } from "~/components/ContentItemWithImage";

export const apiToContentItemProps = (
  item: PostItem
): ContentItemWithImageProps => {
  const { post } = item;
  return {
    imageSrc: heDecodeOrDefault(post.image?.source),
    kicker: heDecodeOrDefault(post.primaryTag?.name),
    body: heDecodeOrDefault(post.subhead),
    headline: heDecodeOrDefault(post.title),
    headlineHref: getRouteFromPostType(post.type, post.slug),
    kickerHref: heDecodeOrDefault(`/tags/${post.primaryTag?.slug}`),
    footer: heDecodeOrDefault(item.metadata),
    date: heDecodeOrDefault(post.dateGmt),
  };
};
